import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const TituloSecao = styled.h2`
  font-weight: 300;
  font-size: 18px;
  line-height: 24px;
  margin: 32px 0 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`

export const TagOpcional = styled.span`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${Cores.PRIMARIA_2};
  border: 1px solid ${Cores.PRIMARIA_2};
  border-radius: 12px;
  padding: 2px 10px;
`

export const AvisoLicenca = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: ${Cores.CINZA_2};
  margin: 0 0 16px;
`

export const CampoFormulario = styled.div`
  margin-bottom: 16px;
  max-width: 420px;
`

export const ListaEnviados = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`
